<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <div class="col-md-12 index-up">
                <app-breadcrumb></app-breadcrumb>
                <h2>{{description?.Title}}</h2>
                <p *ngIf="!isclicked" class="text-primary size18 font-weight-semibold">{{description?.Contenu}}
                </p>
                <p *ngIf="!isclicked" class="font-weight-semibold text-uppercase">{{"AppelOffre.chercher" | translate}}</p>
                <form *ngIf="!isclicked" class="form-ap" #formFilter="ngForm">
                    <div class="form-row">
                        <div class="col-md-3">
                            <label for="tag">{{"AppelOffre.motscle" | translate}}</label>
                            <input ngModel name="ObjetAppelOffre" class="form-control" id="ObjetAppelOffre" type="text" placeholder="{{'AppelOffre.Saisissezmotcles' | translate}}">
                        </div>
                        <div class="col-md-3">
                            <label for="region">{{"AppelOffre.region" | translate}}</label>
                            <select ngModel name="Region" class="form-control" id="region">
                                <option value="">{{"AppelOffre.ChoisissezRegion" | translate}}</option>
                                <option *ngFor="let r of Region" [value]="r.ID">{{r.Title}}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="categorie">{{"AppelOffre.categorie" | translate}}</label>
                            <select ngModel name="Domain" class="form-control" id="categorie">
                                <option value="">{{"AppelOffre.ChoisissezCatégorie" | translate}}</option>
                                <option *ngFor="let c of Categorie" [value]="c">{{c}}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label  for="DatePlis">{{"AppelOffre.DateOuverture" | translate}}</label>
                            <input ngModel name="DatePlis" class="form-control" id="DatePlis" type="date" placeholder="Choisissez une date">
                        </div>
                    </div>
                    <button class="btn btn-info" [class.pr-5]="!isArab" [class.pl-5]="isArab" (click)="lancerFilter(formFilter.value)">{{"AppelOffre.LancerRecherche" | translate}}<span class="icon-search"></span></button>
                </form>
            </div>
        </div>
    </div>

    <div *ngIf="isclicked" class="container">
    <div class="row">
        <div class="col-md-3 side-bar">
        <div class="selected-item">      </div> 
        <nav id="sidebar">
          <app-statique-menu
            [lg]="outputLg"
            [cururl]="currentUrl"
          ></app-statique-menu>
        </nav>
      </div>
      <div class="col-md-9">
            <div *ngIf="isclicked" style="padding: 20px 2rem;">
                <div class="avis_ao">
                    <span>Détail de l'appel d'offre</span>
                </div>
                <div class="tire_ao">
                    N° appel d'offre
                </div>
                <div class="detail_ao">
                    <span>{{selectedOffre?.Title}} </span>
                </div>
                <div class="tire_ao">
                    Objet
                </div>
                <div class="detail_ao">
                    <span id="ctl00_ctl42_g_aca240e3_2a78_4630_894b_603800911dc2_ctl00_L_Objet">
                        {{capitize(selectedOffre?.ObjetAppelOffre)}}
                    </span>
        
                </div>
                <!-- <div class="tire_ao">
                {{converteDate(selectedOffre?.Date_x0020_de_x0020_publication)}}
                </div>
                <div class="detail_ao">
                    <span>{{ converteDate(selectedOffre?.Date_x0020_limite_x0020_de_x0020)}}</span>
        
                </div> -->
                <div class="tire_ao">
                    Date limite de retrait de dossier et de remise des plis
                </div>
                <div class="detail_ao">
                    <span>{{converteDate(selectedOffre?.Date_x0020_limite_x0020_de_x00200)}}</span>
                </div>
        
        
                <div class="tire_ao">
                    Dossier de Consultation
                </div>
                <div class="detail_ao">
        
                    <span id="ctl00_ctl42_g_aca240e3_2a78_4630_894b_603800911dc2_ctl00_L_marche">Pour retrouver le dossier de
                        consultation, merci de vous connecter au portail des marchés publics en suivant ce <a
                            [href]="selectedOffre?.lien_marche_pub?.Url">Lien</a></span>
        
                    <span id="ctl00_ctl42_g_aca240e3_2a78_4630_894b_603800911dc2_ctl00_L_corps"></span>
                    <br>
                </div>
                <div class="tire_ao" *ngIf="selectedOffre?.AttachmentFiles.length!=0">
                    Avis à télécharger
                </div>
                <div class="detail_ao">
                    <div *ngFor="let file of selectedOffre?.AttachmentFiles">
                        <a [href]="file.ServerRelativeUrl"> {{file.FileName}} </a><br>
                    </div>
                </div>
            </div>
        
      </div>
    </div>
  </div>

    
    <section *ngIf="!isclicked" class="c-appels-offres">
        <div class="container">
            <div class="row">
                <div class="col d-flex justify-content-between">
                    <h2 class="size18 text-uppercase mb-3">{{"AppelOffre.ResultatRecherche" | translate}} : </h2>
                    <p class="size18 text-uppercase text-white mt-4 pt-1 mb-3">
                        {{lenth}}
                        {{"AppelOffre.AppelTrouve" | translate}}</p>
                </div>
            </div>
            <!-- <div class="row slickappel" data-aos="fade-up">
                <div *ngFor="let offres of dataOffres" class="col-md-12">
                    <a *ngFor="let offre of offres" routerLink="{{offre.ID}}"
                        class="block-appels d-flex align-items-start flex-column">
                        <div class="d-flex justify-content-between w-100">
                            <div class="num-appel-offre">{{offre.Title}}</div>
                            <div class="date-appels mt-auto">{{converteDate(offre.Date_x0020_de_x0020_publication)}} </div>
                        </div>
                        <h3 class="titre-appels size18"> {{offre.ObjetAppelOffre}} </h3>
                    </a>
                </div>
            </div> -->
            <table id="offres" class="table table-striped table-bordered" style="width:100%">
                <thead>
                    <tr>
                        <th>N° appel d'offres</th>
                        <th>Objet</th>
                        <th>Date limite de retrait de dossier</th>
                    </tr>
                </thead>
            </table>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-white size12 mt-4">{{descriptionFooter?.Contenu}}</p>
                    <p class="text-white size12" [innerHTML]="descriptionFooter?.Variables"></p>
                </div>
            </div>
        </div>
    </section>
</main>